export default "__VITE_ASSET__uJZAERVh__"